<template>
    <v-dialog v-if="dialog" v-model="dialog" max-width="500px" persistent>
        <v-card class="pa-3">
            <v-card-title>
                <h2 class="title">Change Advertiser email</h2>
            </v-card-title>

            <div v-if="loading" class="my-3 px-6">
                <v-progress-linear
                        :indeterminate="loading"
                        :class="{ 'no-opacity': !loading }"
                        style="height: 2px;"
                ></v-progress-linear>
            </div>
            <template v-else>
                <v-card-text class="mt-5">
                    <div>
                        <div class="px-2">
                            <template>
                                <v-text-field
                                    v-model="preparedData.current_email"
                                    label="Current email"
                                    placeholder="Please Enter"
                                    :error-messages="errors($v.preparedData.current_email) || server_errors.current_email"
                                    @focus="resetServerValidation"
                                ></v-text-field>
                                <v-text-field
                                    v-model="preparedData.email"
                                    label="New email"
                                    placeholder="Please Enter"
                                    :error-messages="errors($v.preparedData.email) || server_errors.email"
                                    @focus="resetServerValidation"
                                ></v-text-field>
                                <v-text-field
                                    v-model="preparedData.email_confirmation"
                                    label="New email confirmation"
                                    placeholder="Please Enter"
                                    :error-messages="errors($v.preparedData.email_confirmation) || server_errors.email_confirmation"
                                    @focus="resetServerValidation"
                                ></v-text-field>
                            </template>
                        </div>
                        <v-alert class="pa-2 mt-3" :value="$v.$error" outlined color="error" icon="mdi-alert" transition="scale-transition">
                            <span class="caption">Please fill out form correctly</span>
                        </v-alert>
                        <v-alert class="pa-2 mt-3" :value="!serverValidation" outlined color="error" icon="mdi-alert"
                                 transition="scale-transition">
                            <span class="caption">{{ serverValidationMessage }}</span>
                        </v-alert>
                    </div>
                </v-card-text>
                <v-card-actions class="px-6">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="closeModal">Cancel</v-btn>
                    <v-btn
                            color="primary"
                            :disabled="loadingSave"
                            :loading="loadingSave"
                            @click="CompanyEdit"
                    >Save
                    </v-btn>
                </v-card-actions>
            </template>
        </v-card>
    </v-dialog>
</template>

<script>
    import ApiService from "@/common/api.service"
    import { validationMixin } from "vuelidate"
    import { required, email, sameAs, not} from "vuelidate/lib/validators"
    import { valMessages, getValMessage } from "@/common/error-messages"

    let validations = {};

    export default {
        name: 'AdvertiserChangeEmail',
        mixins: [validationMixin],
        validations() {
            validations = {
                preparedData: {}
            };
            validations.preparedData.current_email = { required, email }
            validations.preparedData.user_id = { required }
            validations.preparedData.email = { required, email, differentFromOldEmail: not(sameAs('current_email')) }
            validations.preparedData.email_confirmation = { required, email, sameAsEmail: sameAs('email') }

            this.errors = getValMessage(valMessages)(validations);
            return validations;
        },
        data: () => ({
            no_data: [null, "", undefined, "null"],
            preparedData: {},
            loading: false,
            loadingSave: false,
            dialog: false,
            serverValidation: true,
            serverValidationMessage: "Oops something went wrong...",
            server_errors: {}
        }),
        mounted() {
            this.$root.$on('AdvertiserChangeEmail', this.openModal)
        },
        beforeDestroy() {
            this.$root.$off('AdvertiserChangeEmail', this.openModal)
        },
        methods: {
            openModal(input) {
                this.organizationData = input
                this.preparedData.current_email = _.cloneDeep(this.organizationData.organization.user.email)
                this.preparedData.user_id = _.cloneDeep(this.organizationData.organization.user.id)
                this.$v.$reset()
                this.resetServerValidation()
                this.dialog = true
            },
            CompanyEdit() {
                this.resetServerValidation()
                this.$v.preparedData.$touch()
                if (!this.$v.preparedData.$invalid) {
                    this.loadingSave = true
                    let body = _.cloneDeep(this.preparedData)
                    ApiService.put('/admin/organization/'+this.organizationData.organization.id+'/change_email', body)
                        .then(response => {
                            this.$root.$emit("notification", {
                                status: "success",
                                text: `Advertiser mail been successfully updated`
                            });
                            this.loadingSave = false
                            this.preparedData = {}
                            this.$emit('done')
                            this.closeModal()
                        })
                        .catch(({response}) => {
                            this.loadingSave = false;
                            this.serverValidation = false;
                            if (response.data.error) {
                                this.serverValidationMessage = this.titleCase(
                                    response.data.error
                                );
                            }
                            if (response.data.message) {
                                this.serverValidationMessage = response.data.message;
                            }
                            if (response.data.errors) {
                                this.server_errors = response.data.errors;
                            }
                        });
                }
            },
            closeModal() {
                this.dialog = false
            },
            titleCase(str) {
                return _.startCase(str.replace(/_/g, " "));
            },
            resetServerValidation() {
                this.serverValidation = true;
                this.serverValidationMessage = "Oops something went wrong...";
                this.server_errors = {};
            },
            errors: getValMessage(valMessages)(validations)
        },
        computed: {
        }
    }
</script>
